"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HCaptcha = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "HCaptcha", { enumerable: true, get: function () { return features_1.HCaptcha; } });
//# sourceMappingURL=index.js.map